import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '../card/card';
import FCLink from '../fc_link/fc_link';

export default class Recirc extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      fastcompany,
      fastcodesign,
      fastcocreate,
      fastcoexist,
      currentSite,
      env
    } = this.props;

    // TODO: This should be moved into the API.
    const properties = [
      {
        key: 'fastcoexist',
        title: 'Ideas',
        data: fastcoexist,
        link: 'https://www.fastcompany.com/ideas'
      },
      {
        key: 'fastcocreate',
        title: 'Entertainment',
        data: fastcocreate,
        link: 'https://www.fastcompany.com/entertainment'
      },
      {
        key: 'fastcodesign',
        title: 'Co.Design',
        data: fastcodesign,
        link: 'https://www.fastcodesign.com'
      },
      {
        key: 'fastcompany',
        title: 'Fast Company',
        data: fastcompany,
        link: 'https://www.fastcompany.com/'
      }
    ];

    return (
      <div className="recirc">
        {properties.map(property =>
          <div key={property.key} className="recirc__col">
            <FCLink currentSite={currentSite} to={property.link} env={env}>
              <h3
                className={`recirc__col-title recirc__col-title--${property.key}`}
              >
                {property.title}
              </h3>
            </FCLink>
            {property.data.map((story, i) =>
              <Card
                env={env}
                metadata={story}
                key={story.id}
                className={`${i ? 'recirc-card--no-image' : ''} recirc`}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

Recirc.propTypes = {
  fastcompany: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fastcodesign: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fastcocreate: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fastcoexist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentSite: PropTypes.string.isRequired,
  env: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/recirc/recirc.js